import { Routes } from '@angular/router';
import { respondentsRoutes } from './survey-respondent/respondents.routes';
import { questionnaireRoutes } from './questionnaire/questionnaire.routes';
import { superAdminOrOwnerGuard } from '../../guards/super-admin-or-owner.guard';

export const adminRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./admin.component').then((m) => m.AdminComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'analytics',
        loadComponent: () =>
          import('./analytics/analytics.component').then(
            (m) => m.AnalyticsComponent,
          ),
      },
      {
        path: 'account',
        loadComponent: () =>
          import('./profile/profile.component').then((m) => m.ProfileComponent),
      },
      {
        path: 'respondents',
        children: respondentsRoutes,
      },
      {
        path: 'forms',
        loadComponent: () =>
          import('./forms/forms.component').then((m) => m.FormsComponent),
      },
      {
        path: 'question-sets',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./question-set-library/question-set-library.component').then(
                (m) => m.QuestionSetLibraryComponent,
              ),
          },
          {
            path: 'import',
            loadComponent: () =>
              import('./question-set-import/question-set-import.component').then(
                (m) => m.QuestionSetImportComponent,
              ),
          },
        ],
      },
      {
        path: 'intents',
        loadComponent: () =>
          import('./intents/intents.component').then((m) => m.IntentsComponent),
      },
      {
        path: 'users',
        canActivate: [superAdminOrOwnerGuard],
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./users/users.component').then((m) => m.UsersComponent),
          },
          {
            path: ':guid',
            loadComponent: () =>
              import('./users/user-detail/user-detail.component').then(
                (m) => m.UserDetailComponent,
              ),
          },
        ],
      },
      {
        path: 'questionnaire-instances',
        canActivate: [superAdminOrOwnerGuard],
        loadComponent: () =>
          import('./questionnaire-instances/questionnaire-instances.component').then(
            (m) => m.QuestionnaireInstancesComponent,
          ),
      },
    ],
  },
  {
    path: 'questionnaire',
    children: questionnaireRoutes,
  },
];
